import { ButtonProps, useSlotRecipe, Text, Button, RecipeVariantProps } from '@chakra-ui/react';
import { SvgIcon } from './chakra-components';
import React from 'react';
import { slotRecipes } from './theme/recipes';


type Props = RecipeVariantProps<typeof slotRecipes.basicButton> & {
	text?: string;
	icon?: SvgIcon
} & Omit<ButtonProps, 'type' | 'size' | 'mode'>;

export function BasicButton({ text, icon, type, size, mode, ...props }: Props) {

	const recipe = useSlotRecipe({ key: 'basicButton' });
	const styles = recipe({ type, size, mode });

	return (
		<Button css={styles.button} {...props}>
			{icon && <SvgIcon src={icon} css={styles.icon} />}
			{text && <Text css={styles.label}>{text}</Text>}
		</Button>
	);
}